import JsUtil from '@/util/JsUtil'

let loaded = false
const init = async () => {
  if (loaded === true) {
    return true
  }
  await JsUtil.loadasync({
    id: 'sc-kakao',
    src: '//developers.kakao.com/sdk/js/kakao.min.js',
  })
  Kakao.init('c85dcc5277165b74ea438446153d2bb8')
  loaded = true
}

const obj = {
  init,
}

export default obj
